import { EventSettleStatus } from '@/interface/enum';

export const isRefunded = (status: EventSettleStatus) => [EventSettleStatus.Refunded, EventSettleStatus.FTRefunded].some(x => x & status);

export const findFirstHalfStatusWithoutResult = (status: number) => [
    EventSettleStatus.FHPostponed,
    EventSettleStatus.Refunded,
    EventSettleStatus.FHSuspendedMatch,
    EventSettleStatus.FHCancelled,
].find(x => x & status);

export const findFullTimeStatusWithoutResult = (status: number) => [
    EventSettleStatus.FTPostponed,
    EventSettleStatus.Refunded,
    EventSettleStatus.FTSuspendedMatch,
    EventSettleStatus.FTCancelled,
    EventSettleStatus.FTRefunded,
].find(x => x & status);

export const findFirstHalfStatusWithResult = (status: number) => [
    EventSettleStatus.FHAbandoned,
    EventSettleStatus.FHCompleteEarly,
].find(x => x & status);

export const findFullTimeStatusWithResult = (status: number) => [
    EventSettleStatus.FTAbandoned,
    EventSettleStatus.FTCompleteEarly,
].find(x => x & status);
